<template>
<div>
    <div v-for="act in activitiesList" class="item activities">
        <!-- Tournament has ended -->
        <template v-if="act.match && act.match.level === 0">
            <img src="images/tournament-dark.png" class="tournament">
            <p>
                <user-link :who="act.user" /> hat das Finale des Turniers "{{ act.tournament.name }}"
                gegen <user-link :who="act.user2" /> gewonnen!
            </p>
        </template>

        <!-- Match played -->
        <template v-else-if="act.type == 'match-played'">
            <div class="double-dp">
                <dp :who="act.user" />
                <dp :who="act.user2" />
            </div>
            <p v-if="act.match.won === undefined">
                <user-link :who="act.user" /> 
                hat gegen 
                <user-link :who="act.user2" /> 
                <template v-if="act.match.level !== null">
                    im {{ act.match.level | round_name }} des Turniers {{ act.tournament.name }}
                </template>
                {{ act.match | score }} 
                gespielt.
            </p>
            <p v-if="act.match.won === true">
                Du hast gegen 
                <user-link :who="act.match.player_other" />
                <template v-if="act.match.level !== null">
                    im {{ act.match.level | round_name }} des Turniers {{ act.tournament.name }}
                </template>
                {{ act.match | score }} 
                gewonnen!
                <strong>ELO {{ act.match.elo_me_delta | plusminus }}</strong>
                <router-link to="/profile/me/stats" class="btn-secondary">Statistik</router-link>
            </p>
            <p v-if="act.match.won === false">
                Schade! Du hast gegen 
                <user-link :who="act.match.player_other" />
                <template v-if="act.match.level !== null">
                    im {{ act.match.level | round_name }} des Turniers {{ act.tournament.name }}
                </template>
                {{ act.match | score }}
                verloren.
                <strong>ELO {{ act.match.elo_me_delta | plusminus }}</strong>
                <router-link to="/profile/me/stats" class="btn-secondary">Statistik</router-link>
            </p>
        </template>

        <!-- Simple text post -->
        <template v-else-if="act.type == 'post-text'">
            <dp :who="act.user" />
            <p class="message"><strong>{{ act.user | name }}:</strong> <span v-html="act.message" v-linkified></span></p>

            <router-link v-if="act.photo && !big" :to="`/timeline/${act.id}`" class="photos">
                <img v-for="index in act.num_photos" 
                    :src="`/storage/photos/${act.photo}_${index-1}_small.jpg`">
            </router-link>

            <div v-if="big" class="photos big">
                <img v-for="index in act.num_photos" 
                    :src="`/storage/photos/${act.photo}_${index-1}_big.jpg`">
            </div>
        </template>

        <!-- Tournament has started -->
        <template v-else-if="act.type == 'tournament-started'">
            <img src="images/tournament-dark.png" class="tournament">
            <p>
                Das Turnier "{{ act.tournament.name }}" hat begonnen.
            </p>
        </template>



        <!-- Byline with time of activity -->
        <small class="pale">
            <router-link :to="`/timeline/${act.id}`">
                {{ act.updated_at | time }}
            </router-link>
        </small>

        <!-- Actions: comment and like -->
        <div class="actions" v-if="!admin">
            <a class="comment" href="#" @click.prevent="commentingOn = act.id"></a>
            <a v-bind:class="[act.liked ? 'red': '', 'like']" href="#" @click.prevent="like(act)"></a>
            <span v-if="act.num_likes > 0" class="num-likes">
                {{ listLikes(act) }}
            </span>
        </div>

        <div class="actions" v-if="admin && act.type == 'post-text'">
            <a href="#" @click.prevent="deletePost(act)">Löschen</a>
        </div>

        <!-- List of comments and comment form -->
        <div class="comments" v-if="act.comments.length > 0 || commentingOn == act.id">
            <div v-for="comment in act.comments" class="item">
                <dp :who="comment.author" />
                <p class="message"><strong>{{ comment.author | name }}:</strong> <span v-html="comment.message" v-linkified></span></p>
                <a href="#" @click.prevent="deleteComment(act, comment)" v-if="admin">Löschen</a>
            </div>
            <form v-if="commentingOn == act.id" @submit.prevent="comment(act)">
                <dp :who="user" />
                <div>
                    <textarea v-model="commentMessage"></textarea>
                    <input type="submit" class="btn-primary" value="Kommentieren">
                </div>
            </form>
        </div>
    </div>
</div>
</template>

<script>
import _ from 'underscore'
import userlink from 'components/user-link.vue'
import dp from 'components/dp.vue'
import base from 'base.vue'

export default {
    mixins: [ base ],
    components: { 'user-link': userlink, 'dp': dp },
    props: [ 'activities', 'big', 'admin' ],
    data () {
        return {
            commentingOn: null,
            commentMessage: ''
        }
    },
    computed: {
        activitiesList () {
            const that = this

            return _.map(this.activities, function(activity) {
                const likes = _.pluck(activity.likes, 'user_id')
                activity.liked = (likes.indexOf(that.user.id) != -1)

                if (activity.type == 'match-played' && !that.admin) {
                    if (activity.match.player_a_id == that.user.id) {
                        activity.match.won = activity.match.winner == 'a'
                        activity.match.player_me = activity.user
                        activity.match.player_other = activity.user2
                        activity.match.points_me = activity.match.points_a
                        activity.match.points_other = activity.match.points_b
                        activity.match.elo_me_delta = activity.match.elo_a_delta
                    } else if (activity.match.player_b_id == that.user.id) {
                        activity.match.won = activity.match.winner == 'b'
                        activity.match.player_me = activity.user2
                        activity.match.player_other = activity.user
                        activity.match.points_me = activity.match.points_b
                        activity.match.points_other = activity.match.points_a
                        activity.match.elo_me_delta = activity.match.elo_b_delta
                    }
                }

                return activity
            })
        }
    },
    methods: {
        like (activity) {
            const that = this

            if (!activity.liked) {
                this.$api.post('timeline/' + activity.id + '/like')
                .then(response => {
                    activity.liked = true
                    activity.num_likes++
                    activity.likes.unshift({ user_id: that.user.id, user: that.user })
                })
            } else {
                this.$api.post('timeline/' + activity.id + '/unlike')
                .then(response => {
                    activity.liked = false
                    activity.num_likes--
                    activity.likes = _.filter(activity.likes, like =>
                        like.user_id != that.user.id)
                })
            }
        },
        comment (activity) {
            const that = this

            this.$api.post('timeline/' + activity.id + '/comment', {
                activity_id: this.commentingOn,
                message: this.commentMessage
            })
            .then(response => {
                activity.comments.push({ message: that.commentMessage, author: that.user, author_id: that.user.id })
                that.commentingOn = null
                that.commentMessage = ''
            })
        },
        listLikes (activity) {
            return this.listNames(_.pluck(activity.likes, 'user'), activity.num_likes)
        },
        deletePost (post) {
            if (!confirm(`Sind Sie sicher, dass Sie den Post von ${post.user.firstname} ${post.user.lastname} löschen möchten?`)) {
                return;
            }

            const that = this
            this.$api.post(`admin/timeline/${post.id}/delete`)
            .then(response => {
                that.activities.splice(that.activities.indexOf(post), 1);
            })
        },
        deleteComment (activity, comment) {
            if (!confirm(`Sind Sie sicher, dass Sie den Post von ${comment.author.firstname} ${comment.author.lastname} löschen möchten?`)) {
                return;
            }

            this.$api.post(`admin/timeline/comment/${comment.id}/delete`)
            .then(response => {
                activity.comments.splice(activity.comments.indexOf(comment), 1);
            })
        }
    },
    filters: {
        score (match) {
            if (match.won === undefined) {
                return `${match.points_a}:${match.points_b}`
            } else {
                return `${match.points_me}:${match.points_other}`
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// timeline.vue?8e70ce46